module.exports = __webpack_public_path__ + "static/img/banner6.49185d3b.png";